<template>
  <div>
  <intro/>
  <buy/>
  <about class="container"/>
  <contact/>
  </div>
</template>

<script>

import Intro from '@/components/snaliens/Intro.vue'
import About from '@/components/snaliens/About.vue'
import Contact from '@/components/snaliens/Contact.vue'
import Buy from '@/components/snaliens/Buy.vue'

export default {
  name: 'SnaliensPage',
  components: 
  {
    Intro,
    About,
    Contact,
    Buy
  },
  data(){
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content
{
  background-color: #1F3764;
  height: 100vh;
}
</style>
